import { render, staticRenderFns } from "./Err.vue?vue&type=template&id=6318a2fc&scoped=true&"
import script from "./Err.vue?vue&type=script&lang=js&"
export * from "./Err.vue?vue&type=script&lang=js&"
import style0 from "./Err.vue?vue&type=style&index=0&id=6318a2fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318a2fc",
  null
  
)

export default component.exports